import React from 'react';

export type NavIconType =
  | 'home'
  | 'map'
  | 'calendar'
  | 'user'
  | 'truck'
  | 'nodes'
  | 'shield'
  | 'card'
  | 'route'
  | 'vehicle'
  | 'alert'
  | 'health'
  | 'audit'
  | 'user-add'
  | 'lock';

type NavIconProps = {
  type: NavIconType;
};

export function NavIcon({ type }: NavIconProps) {
  const paths: Record<NavIconType, React.ReactNode> = {
    home: (
      <>
        <path d="M3 10l9-7 9 7" />
        <path d="M5 9v11h14V9" />
      </>
    ),
    map: (
      <>
        <path d="M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3V6z" />
        <path d="M9 3v15M15 6v15" />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M8 3v4M16 3v4M3 10h18" />
      </>
    ),
    user: (
      <>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21a8 8 0 0116 0" />
      </>
    ),
    truck: (
      <>
        <path d="M3 6h12v10H3zM15 10h4l2 3v3h-6z" />
        <circle cx="7" cy="18" r="2" />
        <circle cx="18" cy="18" r="2" />
      </>
    ),
    nodes: (
      <>
        <circle cx="6" cy="6" r="3" />
        <circle cx="18" cy="12" r="3" />
        <circle cx="7" cy="19" r="3" />
        <path d="M9 7.5l6 3M15.5 14l-6 3.5" />
      </>
    ),
    shield: (
      <>
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
        <path d="M9 12l2 2 4-5" />
      </>
    ),
    card: (
      <>
        <rect x="3" y="6" width="18" height="12" rx="2" />
        <path d="M3 10h18M7 15h3" />
      </>
    ),
    route: (
      <>
        <circle cx="6" cy="18" r="3" />
        <circle cx="18" cy="6" r="3" />
        <path d="M8.5 16c4-2 7-4 7-7" />
      </>
    ),
    vehicle: (
      <>
        <path d="M5 11l1.5-4h11L19 11" />
        <path d="M4 11h16v6H4z" />
        <circle cx="7" cy="17" r="1.5" />
        <circle cx="17" cy="17" r="1.5" />
      </>
    ),
    alert: (
      <>
        <path d="M12 3L2.5 20h19L12 3z" />
        <path d="M12 9v5" />
        <path d="M12 17h.01" />
      </>
    ),
    health: (
      <>
        <path d="M3 12h4l2-5 4 10 2-5h6" />
        <path d="M12 21C6 17.5 3 14 3 9.5A4.5 4.5 0 0112 8a4.5 4.5 0 019 1.5c0 4.5-3 8-9 11.5z" />
      </>
    ),
    audit: (
      <>
        <path d="M6 3h12v18H6z" />
        <path d="M9 8h6M9 12h6M9 16h4" />
      </>
    ),
    'user-add': (
      <>
        <circle cx="9" cy="8" r="4" />
        <path d="M3 21a6 6 0 0112 0M19 8v6M16 11h6" />
      </>
    ),
    lock: (
      <>
        <rect x="5" y="10" width="14" height="11" rx="2" />
        <path d="M8 10V7a4 4 0 018 0v3M12 14v3" />
      </>
    ),
  };

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths[type]}
    </svg>
  );
}
